// Shared constants used by more than one component of the redesigned site.
// Content specific to a single section (feature list, sheet list, premium points,
// social links) lives inline in that section's own component instead.

export const IOS_URL = 'https://apps.apple.com/in/app/thriill-train-your-ear/id6744299502';
export const ANDROID_URL = 'https://play.google.com/store/apps/details?id=com.thriill.app';

export const NAV_ITEMS = [
  { label: 'Home', href: '#top', home: true },
  { label: 'Try it', href: '#teaser' },
  { label: 'Features', href: '#features' },
  { label: 'Repertoire', href: '#repertoire' },
  { label: 'Premium', href: '#premium' },
  { label: 'Download & Contact', href: '#download' },
];

export const HERO_EMBED =
  'https://www.youtube-nocookie.com/embed/Tf2FhaH9suA?autoplay=1&mute=1&loop=1&playlist=Tf2FhaH9suA&playsinline=1&rel=0&modestbranding=1&enablejsapi=1&controls=0&cc_load_policy=0&iv_load_policy=3&disablekb=1';

export const REPERTOIRE_EMBED =
  'https://www.youtube-nocookie.com/embed/unhLZzvQg_s?autoplay=1&mute=1&loop=1&playlist=unhLZzvQg_s&start=1&end=15&playsinline=1&rel=0&modestbranding=1&controls=0&cc_load_policy=0&iv_load_policy=3&disablekb=1';

// Brevo sign-up form "Theory Book waitlist" (adds people to the Brevo list of the same
// name, with double opt-in). This is the form's "serve" URL from Brevo's Simple HTML
// embed code. Set it to '' to switch the waitlist off.
export const BOOK_WAITLIST_URL =
  'https://d450a20b.sibforms.com/serve/MUIFAHmzJBnc7r0ZwhdeE71HVT4wABAZv3xH6vUlQMe2oqX50_bOZ7nbJ5P25bHBR8cnu_OPf6CYeU709POjML4ab2f7M1mmw7ege_sr4iMOTTMK_BQ-GIdY3WDJgUHbz_94Kvwz3LDZ8Qu0AKfvRFYXmWnW1GV-y3S0us2ct10IL4JZ9mIGomsQ3xwi23AuxJXONM84HRKWslZOUg==';
